var render = function render(){var _vm=this,_c=_vm._self._c;return _c('session-select-base',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.items,"loading":_vm.loading,"item-text":"id","hide-details":"auto","nav":_vm.nav,"prev-id":_vm.prevId,"next-id":_vm.nextId},on:{"input":function($event){return _vm.$emit('input', $event)}}},'session-select-base',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }